import Styled from "styled-components";

export default Styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
`;
